import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;

const ConnectionStatus = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${props => props.connected ? '#4CAF50' : '#f44336'};
  margin-left: 10px;
  gap: 8px;
`;

const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.connected ? '#4CAF50' : '#f44336'};
  margin-right: 5px;
  animation: ${props => props.connecting ? pulse : 'none'} 1s infinite;
`;

const SocketConnectionIndicator = ({ connected, connecting = false }) => {
  let statusText = 'Offline';
  
  if (connecting) {
    statusText = 'Connecting...';
  } else if (connected) {
    statusText = 'Live';
  }

  return (
    <ConnectionStatus connected={connected}>
      <StatusDot connected={connected} connecting={connecting} />
      {statusText}
    </ConnectionStatus>
  );
};

export default SocketConnectionIndicator;
